<template>
    <section class="md-testimionial comment-list">
        <div class="total" ref="scrollIntoDom">
            {{ testimonialTitle || $t('md-testimonial.recommendations') }}
            <span v-if="comments.length">({{ comments.length }})</span>
        </div>
        <ul v-if="comments.length" class="comment-list">
            <comment
                :enableShare="enableShare"
                :theme="commentTheme"
                :moreLine="moreLine"
                :mobileMoreLine="mobileMoreLine"
                v-for="comment in showComments"
                :user-comment="comment"
                :key="comment.id"
            >
                <img v-if="comment.rmaTrackPixelUrl" class="rma-pixel-img" :src="comment.rmaTrackPixelUrl" loading="lazy" />
                <ReviewSourceLogo :sourceType="comment.sourceType" />
            </comment>
            <!--  Only displayed when the total number of pages is greater than one page  -->
            <pagination
                v-if="totalPage > 1"
                :totalPage="totalPage"
                @pageChange="pageChange"
                :pageSize="pageSize"
                :currentPage="currentPage"
            />
        </ul>
        <p v-else class="no-review">
            {{ $t('md-testimonial.noReviewsYet') }}
        </p>
    </section>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import comment from './comment.vue';
import ReviewSourceLogo from '../review-source-logo.vue';
import util from '@/common/util';
export default {
    name: 'comment-list',
    i18next: {
        ns: 'md-testimonial'
    },
    components: {
        comment,
        ReviewSourceLogo,
        pagination: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "components/pagination"*/ '@/components/pagination/index.vue'
            ))
    },
    props: {
        moreLine: {
            type: Number
        },
        mobileMoreLine: {
            type: Number
        },
        testimonialTitle: {
            type: String
        },
        comments: {
            type: Array
        },
        showTitleZillow: {
            type: Boolean,
            default: true
        },
        pageSize: {
            type: Number,
            default: 5
        },
        commentTheme: {
            type: String,
            default: 'default'
        },
        enableShare: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        showComments() {
            if (this.totalPage === 1) {
                return this.comments; //  One page returns all values
            } else {
                let start = (this.currentPage - 1) * this.pageSize;
                let last = start + this.pageSize;
                if (last > this.comments.length) {
                    last = this.comments.length; //  If the length exceeds, the length of the array is displayed
                }
                return this.comments.slice(start, last);
            }
        },
        totalPage() {
            //  Calculate the total number of pages
            return Math.ceil(this.comments.length / this.pageSize);
        }
    },
    data: function() {
        return {
            currentPage: 1
        };
    },
    methods: {
        pageChange(pageInfo) {
            this.currentPage = pageInfo.page;
            if (this.$refs.scrollIntoDom?.getBoundingClientRect) {
                let pos = this.$refs.blogs.getBoundingClientRect();
                let y = pos.top + document.documentElement.scrollTop - 100;
                if (y < 0) {
                    y = 0;
                }
                util.winScrollTop(y);
            } else if (!this.noScroll) {
                util.winScrollTop(0); // Jump to the top after turning the page
            }
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';

.md-testimionial.comment-list {
    .rma-pixel-img{
      display: block;
        width: 0;
        height: 0;
    }
    .total {
        color: #010102;
        font-size: 24px;
    }
    .comment-list {
        margin-top: 12px;
        border-top: 1px solid #e6e6e6;
    }
    .no-review {
        width: 100%;
        height: 220px;
        font-size: 18px;
        color: #505050;
        opacity: 0.34;
        margin-top: 12px;
        border-top: 1px solid rgba(80, 80, 80, 0.2);
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .comment-item {
        margin-top: 20px;
        position: relative;
        .comment-top {
            display: flex;
            .comment-head {
                width: 60px;
                height: 60px;
                position: relative;
                border-radius: 50%;
                overflow: hidden;
                margin-right: 22px;
                span {
                    display: block;
                    background-color: #d9d9d9;
                    text-align: center;
                    font-size: 36px;
                    color: #fff;
                    text-transform: uppercase;
                    line-height: 60px;
                }
            }
            .comment-name {
                font-size: 20px;
                color: #282828;
                padding-right: 80px;
            }
            .name-star {
                flex: 1;
            }
        }
        .comment-time {
            position: absolute;
            right: 0;
            top: 5px;
            font-size: 14px;
            color: #c8c8c8;
        }
    }
}
</style>
